var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.value.default_value.length < 1 && !_vm.value.unique_id
    ? _c("empty", { attrs: { value: _vm.value } })
    : _c("div", { staticClass: "saas_module_plate_swipe_inner_padding" }, [
        _c(
          "div",
          {
            staticClass: "saas_module_plate_swipe",
            style: { backgroundColor: _vm.value.config.bg_color || "#fff" },
          },
          [
            _vm.value.config.type === "1"
              ? _c("div", { staticClass: "header" }, [
                  _c("div", { staticClass: "title" }, [
                    _vm._v(_vm._s(_vm.value.config.name)),
                  ]),
                  _c("i", { staticClass: "el-icon el-icon-arrow-right more" }),
                ])
              : _vm._e(),
            _vm.value.config.type === "2"
              ? _c("el-image", {
                  staticStyle: { width: "100%" },
                  attrs: { src: _vm.value.config.header_image },
                })
              : _vm._e(),
            _c(
              "div",
              { staticClass: "content" },
              _vm._l(_vm.value.default_value, function (item, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    staticClass: "product",
                    class: {
                      product2: _vm.value.config.image_style == "2",
                      error:
                        _vm.value.config.image_style == "2"
                          ? !item.thumb
                          : !item.swipe_image && !item.thumb,
                    },
                    style: {
                      backgroundImage: "url(" + _vm.getImg(item) + ")",
                    },
                  },
                  [
                    _vm.value.config.image_style != "2"
                      ? [
                          item.status_cn
                            ? _c(
                                "div",
                                { class: ["status", "status_" + item.status] },
                                [_vm._v(" " + _vm._s(item.status_cn) + " ")]
                              )
                            : _vm._e(),
                          _c("div", { staticClass: "name" }, [
                            _vm._v(" " + _vm._s(item.title) + " "),
                          ]),
                        ]
                      : _vm._e(),
                  ],
                  2
                )
              }),
              0
            ),
          ],
          1
        ),
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }